<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

/**
 * Starter component
 */
export default {
  page: {
    title: "Backdoors",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Backdoors",
      name : "",
      total : "",
      id : "",
      product_id : "",
      product : null,
      member : null,
      breadcumbs: [
        {
          text: "Backdoors",
          active: true
        }
      ]
    };
  },
  computed: {
    items() { return this.$store.getters['setting/willWinns'] },
    products() { return this.$store.getters['product/items'] },
    members() { return this.$store.getters['users/items'] },
    state() { return this.$store.getters['setting/state'] },
    loading() { return this.$store.getters['setting/loading'] },
    message() { return this.$store.getters['setting/message'] },
    error() { return this.$store.getters['setting/error'] },
  },
  mounted(){
    // this.$store.dispatch("setting/getwillwinns")
    this.$store.dispatch("users/get")
    this.$store.dispatch("product/get")
    //   this.getSoals();
  },
  methods:{
    getWillwinns(){
        this.$store.dispatch("setting/getwillwinns",this.product_id.id)
    },
    reset(){
    },
    showCreate(){
          this.reset();
          this.$store.commit("setting/SET_STATE","CREATE")
    },
    showList(){
        this.reset();
        this.$store.commit("setting/SET_STATE","LIST")
    },
    save(){
      var param = {
          product_id : this.product.id,
          member_id : this.member.id
      }
      this.$store.dispatch("setting/createWillWinns",param)
      this.reset();
    },
    edit(data){
        this.reset();
        this.name = data.name
        this.total = data.total
        this.id = data.id
        this.$store.commit("setting/SET_STATE","EDIT")
    },
    update(){
      var param = {
          name : this.name,
          total : this.total,
          id : this.id,
      }
      this.$store.dispatch("setting/edit",param)
      this.reset();
    },
    confirm(id) {
        this.reset();
      Swal.fire({
        title: "Apakah Anda Yakin ?",
        text: "Data Yang Di hapus Tidak dapat di kembalikan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Hapus !"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("setting/delete",id).then(()=>this.$store.dispatch("setting/getwillwinns",this.product_id.id))
          Swal.fire("Deleted!", "Berhasil Data Akan Segera Terhapus.", "success");
        }else{
          Swal.fire("Cancel!", "Data Tidak Terhapus", "error");
        }
      });
    },
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="breadcumbs" />
      <div class="row">
        <div class="col-md-12">
            <b-alert show dismissible fade v-show="message != ''">{{message}}</b-alert>
        </div>
        <!-- start list -->
        <div class="col-md-12" v-if="state == 'LIST'">
          <button class="btn btn-pill btn-primary mb-2" @click="showCreate()"> <i class="bx bx-user-plus"></i> Tambah Data</button>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Backdoor Setting</h4>
              <div class="row">
                  <div class="col-md-6 col-md-offset-6 my-2">
                      <select v-model="product_id" class="form-control" @change="getWillwinns()">
                          <option v-for="product in products" :key="product.id" :value="product">{{product.name}}</option>
                      </select>
                  </div>
                  <div class="col-md-6 d-flex justify-content-end align-items-end my-4">
                      <strong>Total Hadiah</strong> : {{this.product_id.total}}
                  </div>
              </div>
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th>User</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="list in items" :key="list.id">
                      <td>{{list.product.name}}</td>
                      <td>{{list.member.name}} ({{list.member.email}})</td>
                      <td>
                          <button class="btn btn-danger btn-sm  mx-1" @click="confirm(list.id)" v-b-tooltip.hover title="Delete" ><i class="bx bx-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- end list -->
        <!-- start create -->
          <div class="col-md-12" v-if="state == 'CREATE'">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Setting Winner</h4>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name" class="control-label">Product <span class="text-danger">*</span></label>
                        <select v-model="product" class="form-control">
                            <option v-for="product in products" :key="product.id" :value="product">{{product.name}}</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="name" class="control-label">User <span class="text-danger">*</span></label>
                        <select v-model="member" class="form-control">
                            <option v-for="member in members" :key="member.id" :value="member">{{member.name}} | {{member.email}}</option>
                        </select>
                      </div>
                      <!-- <div class="form-group">
                        <label for="name" class="control-label">Division <span class="text-danger">*</span></label>
                        <select class="form-control" v-model="division_id">
                            <option v-for="divisions in division" :key="divisions.id" :value="divisions.id">{{divisions.name}}</option>
                        </select>
                      </div> -->
                    </div>
                  </div>
              </div>
              <div class="card-footer">
                <button class="btn btn-danger btn-sm mx-1" @click="showList()"  v-b-tooltip.hover title="Cancel"><i class="bx bx-left-arrow-alt"></i> Cancel</button>
                <button class="btn btn-info btn-sm  mx-1" @click="save()" :disabled="loading" v-b-tooltip.hover title="Save" ><i v-if="loading" class="bx bx-loader-circle"></i> <i v-else class="bx bxs-cloud-upload"></i> Save</button>
              </div>
            </div>
          </div>
        <!-- end create -->
      </div>
  </Layout>
</template>